import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import SendFormComponent from './SendFormComponent';
import { kycVerificationLevelsSelector } from 'apex-web/lib/redux/selectors/kycLevelsSelectors';
import { closeSidePane } from 'apex-web/lib/redux/actions/sidePaneActions';
import { productWithdrawLimitsSelector } from '../../../redux/selectors/depositWithdrawalSelectors';

const mapStateToProps = state => {
  const formValue = formValueSelector('SendForm');

  const { disableWithdraw } = kycVerificationLevelsSelector(state);
  const userEmail = state.user.userInfo.Email;
  const withdrawError = !!state.withdraw.error;

  const {
    DailyWithdrawLimit,
    DailyWithdrawNotionalLimit,
    MonthlyWithdrawLimit,
    MonthlyWithdrawNotionalLimit,
    YearlyWithdrawLimit,
    YearlyWithdrawNotionalLimit
  } =
    productWithdrawLimitsSelector(state) || {};

  const dailyLimitDisabled = DailyWithdrawLimit === 0;
  const dailyNotionalLimitDisabled = DailyWithdrawNotionalLimit === 0;
  const monthlyLimitDisabled = MonthlyWithdrawLimit === 0;
  const monthlyNotionalLimitDisabled = MonthlyWithdrawNotionalLimit === 0;
  const yearlyLimitDisabled = YearlyWithdrawLimit === 0;
  const yearlyNotionalLimitDisabled = YearlyWithdrawNotionalLimit === 0;

  const showWithdrawLimitWarningMessage =
    dailyLimitDisabled ||
    dailyNotionalLimitDisabled ||
    monthlyLimitDisabled ||
    monthlyNotionalLimitDisabled ||
    yearlyLimitDisabled ||
    yearlyNotionalLimitDisabled;

  return {
    disableWithdraw,
    userEmail,
    withdrawError,
    Amount: formValue(state, 'Amount'),
    showWithdrawLimitWarningMessage
  };
};

const mapDispatchToProps = dispatch => ({
  verificationOnClick: () => dispatch(closeSidePane())
});

const SendForm = reduxForm({
  form: 'SendForm',
  onSubmit: () => {}
})(SendFormComponent);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendForm);
